<template>
    <v-card elevation="0" class="annotation-note">
        <slot></slot>
    </v-card>
</template>

<script>
import Vue from "vue";

export default Vue.extend({});
</script>

<style lang="sass" scoped>
.annotation-note
    background-color: $color-background
    padding: 12px 24px
    width: 70%
</style>
